import React, { useState } from 'react';
import theme from './BuyerDocumentCardDesktop.module.scss';
import { Trans } from '@lingui/react/macro';
import { SimpleCard, CardSection } from '@/components/Cards';
import { DateDisplay } from '@/components/localization';
import { Button, ButtonBar, useBreakpoint } from '@ygtechnologies/rubus-ui';
import { faDownload, faHistory } from '@fortawesome/pro-light-svg-icons';
import { BuyerDocumentCardInternalProps } from '../BuyerDocumentCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FileType } from '@ygtechnologies/rubus-frontend-utilities';
import ModelViewerModal from '@/components/ModelViewer/ModelViewerModal';
import { BuyerDocumentIcon } from '../../BuyerDocumentIcon';

const BuyerDocumentCardDesktop: React.FC<BuyerDocumentCardInternalProps> = ({
    subTitle: name,
    icon,
    title: typeName,
    lastModified,
    versionNumber,
    downloadLink,
    openLink,
    fileMetadata,
    onLinkClick,
    onHistoryClick,
    versionId,
}) => {
    const [viewModelIsOpen, setViewModelIsOpen] = useState(false);
    const isDesktop = useBreakpoint().up('lg');
    const buttonSize = isDesktop ? 'md' : 'sm';
    return (
        <SimpleCard className={theme.card}>
            <BuyerDocumentIcon fileMetadata={fileMetadata} />

            <a onClick={onLinkClick} className={theme.label} href={openLink} target="_blank" rel="noopener noreferrer">
                <div>
                    {icon && <FontAwesomeIcon className={theme.typeIcon} icon={icon} />}
                    {typeName}
                </div>
                <small>{name}</small>
            </a>

            {lastModified && (
                <CardSection width="15%" caption={<Trans>Modified</Trans>}>
                    <DateDisplay value={lastModified} />
                </CardSection>
            )}

            {versionNumber && (
                <CardSection width="10%" caption={<Trans>Version</Trans>}>
                    {versionNumber}
                </CardSection>
            )}

            <ButtonBar margins="none" noWrap className={theme.buttons}>
                {fileMetadata.fileType === FileType.IfcModel && versionId && (
                    <>
                        <Button size={buttonSize} onClick={() => setViewModelIsOpen(true)} variant="tertiary">
                            {isDesktop ? <Trans>View BIM model</Trans> : undefined}
                        </Button>
                        <ModelViewerModal
                            isOpen={viewModelIsOpen}
                            toggle={() => setViewModelIsOpen(!viewModelIsOpen)}
                            versionId={versionId}
                        />
                    </>
                )}

                <Button as="a" size={buttonSize} icon={faDownload} variant="tertiary" href={downloadLink} target="_blank">
                    {isDesktop ? <Trans>Download</Trans> : undefined}
                </Button>

                {onHistoryClick && (
                    <Button size={buttonSize} onClick={onHistoryClick} icon={faHistory} variant="tertiary">
                        {isDesktop ? <Trans>Show history</Trans> : undefined}
                    </Button>
                )}
            </ButtonBar>
        </SimpleCard>
    );
};

export default BuyerDocumentCardDesktop;
